const selectAdebifyEnabled = (state) => state.adebify.isEnabled;
const selectAdebifyLoading = (state) => state.adebify.isLoading;
const selectAdebifyChecked = (state) => state.adebify.isChecked;

// account-mapping (isAdebifyEnabled) already checks manage_account on the server.
const selectAdebifyAccessible = (state) => selectAdebifyEnabled(state);

export {
  selectAdebifyEnabled,
  selectAdebifyLoading,
  selectAdebifyChecked,
  selectAdebifyAccessible,
};
